// https://endgrate.com/api/integrations?method=IMPORT
const MERGELINK_INTEGRATIONS = [
  {
    provider: {
      name: "accelo",
      display_name: "Accelo",
      url: "https://www.accelo.com/",
      image: "https://endgrate.nyc3.cdn.digitaloceanspaces.com/integration/accelo.png",
      auth_type: "oauth",
      endgrate_provider_type: "CRM"
    },
    integrations: [
      {
        object_name: "companies",
        label: "Company",
        plural_label: "Companies",
        name: "get-companies",
        display_name: "Get Companies",
        method: "IMPORT",
        endgrate_type: "crm-company",
        supports_associations: false
      },
      {
        object_name: "contacts",
        label: "Contact",
        plural_label: "Contacts",
        name: "get-contacts",
        display_name: "Get Contacts",
        method: "IMPORT",
        endgrate_type: "crm-contact",
        supports_associations: false
      },
      {
        object_name: "tasks",
        label: "Task",
        plural_label: "Tasks",
        name: "get-tasks",
        display_name: "Get Tasks",
        method: "IMPORT",
        endgrate_type: "crm-task",
        supports_associations: false
      }
    ]
  },
  {
    provider: {
      name: "activecampaign",
      display_name: "Active Campaign",
      url: "https://www.activecampaign.com/",
      image: "https://endgrate.nyc3.cdn.digitaloceanspaces.com/integration/activecampaign.png",
      auth_type: "custom",
      endgrate_provider_type: "CRM"
    },
    integrations: [
      {
        object_name: "contacts",
        label: "Contact",
        plural_label: "Contacts",
        name: "get-contacts",
        display_name: "Get Contacts",
        method: "IMPORT",
        endgrate_type: "crm-contact",
        supports_associations: false
      },
      {
        object_name: "accounts",
        label: "Account",
        plural_label: "Accounts",
        name: "get-accounts",
        display_name: "Get Accounts",
        method: "IMPORT",
        endgrate_type: "crm-company",
        supports_associations: false
      },
      {
        object_name: "users",
        label: "User",
        plural_label: "Users",
        name: "get-users",
        display_name: "Get Users",
        method: "IMPORT",
        endgrate_type: "crm-user",
        supports_associations: false
      }
    ]
  },
  {
    provider: {
      name: "affinity",
      display_name: "Affinity",
      url: "https://www.affinity.co/",
      image: "https://endgrate.nyc3.cdn.digitaloceanspaces.com/integration/affinity.png",
      auth_type: "api_key",
      endgrate_provider_type: "CRM"
    },
    integrations: [
      {
        object_name: "companies",
        label: "Company",
        plural_label: "Companies",
        name: "get-companies",
        display_name: "Get Companies",
        method: "IMPORT",
        endgrate_type: "crm-company",
        supports_associations: false
      },
      {
        object_name: "people",
        label: "Person",
        plural_label: "People",
        name: "get-people",
        display_name: "Get People",
        method: "IMPORT",
        endgrate_type: "crm-contact",
        supports_associations: false
      }
    ]
  },
  {
    provider: {
      name: "ams360",
      display_name: "AMS360",
      url: "https://www.vertafore.com/products/ams360",
      image: "https://endgrate.nyc3.cdn.digitaloceanspaces.com/integration/ams360.png",
      auth_type: "custom",
      endgrate_provider_type: "CRM"
    },
    integrations: [
      {
        object_name: "activities",
        label: "Activity",
        plural_label: "Activities",
        name: "get-activities",
        display_name: "Get Activities",
        method: "IMPORT",
        endgrate_type: "crm-activity",
        supports_associations: true
      },
      {
        object_name: "customers",
        label: "Customer",
        plural_label: "Customers",
        name: "get-customers",
        display_name: "Get Customers",
        method: "IMPORT",
        endgrate_type: "crm-contact",
        supports_associations: false
      },
      {
        object_name: "policies",
        label: "Policy",
        plural_label: "Policies",
        name: "get-policies",
        display_name: "Get Policies",
        method: "IMPORT",
        endgrate_type: "crm-policy",
        supports_associations: true
      }
    ]
  },
  {
    provider: {
      name: "apollo",
      display_name: "Apollo",
      url: "https://www.apollo.io/",
      image: "https://endgrate.nyc3.cdn.digitaloceanspaces.com/integration/apollo.png",
      auth_type: "api_key",
      endgrate_provider_type: "CRM"
    },
    integrations: [
      {
        object_name: "contacts",
        label: "Contact",
        plural_label: "Contacts",
        name: "get-contacts",
        display_name: "Get Contacts",
        method: "IMPORT",
        endgrate_type: "crm-contact",
        supports_associations: true
      },
      {
        object_name: "companies",
        label: "Company",
        plural_label: "Companies",
        name: "get-companies",
        display_name: "Get Companies",
        method: "IMPORT",
        endgrate_type: "crm-company",
        supports_associations: false
      },
      {
        object_name: "users",
        label: "User",
        plural_label: "Users",
        name: "get-users",
        display_name: "Get Users",
        method: "IMPORT",
        endgrate_type: "crm-user",
        supports_associations: false
      }
    ]
  },
  {
    provider: {
      name: "appliedepic",
      display_name: "Applied Epic",
      url: "https://www.appliedsystems.com/",
      image: "https://endgrate.nyc3.cdn.digitaloceanspaces.com/integration/appliedepic.png",
      auth_type: "custom",
      endgrate_provider_type: "CRM"
    },
    integrations: [
      {
        object_name: "clients",
        label: "Client",
        plural_label: "Clients",
        name: "get-clients",
        display_name: "Get Clients",
        method: "IMPORT",
        endgrate_type: "other",
        supports_associations: false
      },
      {
        object_name: "people",
        label: "Person",
        plural_label: "People",
        name: "get-people",
        display_name: "Get People",
        method: "IMPORT",
        endgrate_type: "crm-contact",
        supports_associations: false
      },
      {
        object_name: "policies",
        label: "Policy",
        plural_label: "Policies",
        name: "get-policies",
        display_name: "Get Policies",
        method: "IMPORT",
        endgrate_type: "crm-policy",
        supports_associations: true
      }
    ]
  },
  {
    provider: {
      name: "brevo",
      display_name: "Brevo",
      url: "https://www.brevo.com",
      image: "https://endgrate.nyc3.cdn.digitaloceanspaces.com/integration/brevo.png",
      auth_type: "api_key",
      endgrate_provider_type: "CRM"
    },
    integrations: [
      {
        object_name: "contacts",
        label: "Contact",
        plural_label: "Contacts",
        name: "get-contacts",
        display_name: "Get Contacts",
        method: "IMPORT",
        endgrate_type: "crm-contact",
        supports_associations: false
      },
      {
        object_name: "users",
        label: "User",
        plural_label: "Users",
        name: "get-users",
        display_name: "Get Users",
        method: "IMPORT",
        endgrate_type: "crm-user",
        supports_associations: false
      }
    ]
  },
  {
    provider: {
      name: "capsulecrm",
      display_name: "Capsule",
      url: "https://capsulecrm.com/",
      image: "https://endgrate.nyc3.cdn.digitaloceanspaces.com/integration/capsule.png",
      auth_type: "oauth",
      endgrate_provider_type: "CRM"
    },
    integrations: [
      {
        object_name: "parties",
        label: "Party",
        plural_label: "Parties",
        name: "get-parties",
        display_name: "Get Parties",
        method: "IMPORT",
        endgrate_type: "crm-contact",
        supports_associations: true
      },
      {
        object_name: "users",
        label: "User",
        plural_label: "Users",
        name: "get-users",
        display_name: "Get Users",
        method: "IMPORT",
        endgrate_type: "crm-user",
        supports_associations: false
      }
    ]
  },
  {
    provider: {
      name: "close",
      display_name: "Close",
      url: "https://www.close.com/",
      image: "https://endgrate.nyc3.cdn.digitaloceanspaces.com/integration/close.png",
      auth_type: "api_key",
      endgrate_provider_type: "CRM"
    },
    integrations: [
      {
        object_name: "leads",
        label: "Lead",
        plural_label: "Leads",
        name: "get-leads",
        display_name: "Get Leads",
        method: "IMPORT",
        endgrate_type: "crm-lead",
        supports_associations: true
      },
      {
        object_name: "users",
        label: "User",
        plural_label: "Users",
        name: "get-users",
        display_name: "Get Users",
        method: "IMPORT",
        endgrate_type: "crm-user",
        supports_associations: false
      }
    ]
  },
  {
    provider: {
      name: "cloze",
      display_name: "Cloze",
      url: "cloze.com",
      image: "https://endgrate.nyc3.cdn.digitaloceanspaces.com/integration/cloze.png",
      auth_type: "custom",
      endgrate_provider_type: "CRM"
    },
    integrations: [
      {
        object_name: "companies",
        label: "Company",
        plural_label: "Companies",
        name: "get-companies",
        display_name: "Get Companies",
        method: "IMPORT",
        endgrate_type: "crm-company",
        supports_associations: false
      },
      {
        object_name: "contacts",
        label: "Contact",
        plural_label: "Contacts",
        name: "get-contacts",
        display_name: "Get Contacts",
        method: "IMPORT",
        endgrate_type: "crm-contact",
        supports_associations: false
      },
      {
        object_name: "users",
        label: "User",
        plural_label: "Users",
        name: "get-users",
        display_name: "Get Users",
        method: "IMPORT",
        endgrate_type: "crm-user",
        supports_associations: false
      }
    ]
  },
  {
    provider: {
      name: "copper",
      display_name: "Copper",
      url: "https://copper.com/",
      image: "https://endgrate.nyc3.cdn.digitaloceanspaces.com/integration/copper.png",
      auth_type: "custom",
      endgrate_provider_type: "CRM"
    },
    integrations: [
      {
        object_name: "companies",
        label: "Company",
        plural_label: "Companies",
        name: "get-companies",
        display_name: "Get Companies",
        method: "IMPORT",
        endgrate_type: "crm-company",
        supports_associations: true
      },
      {
        object_name: "leads",
        label: "Lead",
        plural_label: "Leads",
        name: "get-leads",
        display_name: "Get Leads",
        method: "IMPORT",
        endgrate_type: "crm-lead",
        supports_associations: true
      },
      {
        object_name: "people",
        label: "Person",
        plural_label: "People",
        name: "get-people",
        display_name: "Get People",
        method: "IMPORT",
        endgrate_type: "crm-contact",
        supports_associations: true
      },
      {
        object_name: "users",
        label: "User",
        plural_label: "Users",
        name: "get-users",
        display_name: "Get Users",
        method: "IMPORT",
        endgrate_type: "crm-user",
        supports_associations: false
      },
      {
        object_name: "opportunities",
        label: "Opportunity",
        plural_label: "Opportunities",
        name: "get-opportunities",
        display_name: "Get Opportunities",
        method: "IMPORT",
        endgrate_type: "crm-opportunity",
        supports_associations: false
      }
    ]
  },
  {
    provider: {
      name: "constantcontact",
      display_name: "Constant Contact",
      url: "https://www.constantcontact.com/",
      image: "https://endgrate.nyc3.cdn.digitaloceanspaces.com/integration/constantcontact.png",
      auth_type: "oauth",
      endgrate_provider_type: "CRM"
    },
    integrations: [
      {
        object_name: "contacts",
        label: "Contact",
        plural_label: "Contacts",
        name: "get-contacts",
        display_name: "Get Contacts",
        method: "IMPORT",
        endgrate_type: "crm-contact",
        supports_associations: false
      }
    ]
  },
  {
    provider: {
      name: "endear",
      display_name: "Endear",
      url: "https://endearhq.com/",
      image: "https://endgrate.nyc3.cdn.digitaloceanspaces.com/integration/endear.png",
      auth_type: "api_key",
      endgrate_provider_type: "CRM"
    },
    integrations: [
      {
        object_name: "notes",
        label: "Note",
        plural_label: "Notes",
        name: "get-notes",
        display_name: "Get Notes",
        method: "IMPORT",
        endgrate_type: "crm-note",
        supports_associations: false
      },
      {
        object_name: "customers",
        label: "Customer",
        plural_label: "Customers",
        name: "get-customers",
        display_name: "Get Customers",
        method: "IMPORT",
        endgrate_type: "crm-customer",
        supports_associations: false
      },
      {
        object_name: "tasks",
        label: "Task",
        plural_label: "Tasks",
        name: "get-tasks",
        display_name: "Get Tasks",
        method: "IMPORT",
        endgrate_type: "crm-task",
        supports_associations: false
      }
    ]
  },
  {
    provider: {
      name: "freshsales",
      display_name: "Freshsales",
      url: "https://www.freshworks.com/crm/sales/",
      image: "https://endgrate.nyc3.cdn.digitaloceanspaces.com/integration/freshworks.png",
      auth_type: "custom",
      endgrate_provider_type: "CRM"
    },
    integrations: [
      {
        object_name: "contacts",
        label: "Contact",
        plural_label: "Contacts",
        name: "get-contacts",
        display_name: "Get Contacts",
        method: "IMPORT",
        endgrate_type: "crm-contact",
        supports_associations: false
      },
      {
        object_name: "accounts",
        label: "Account",
        plural_label: "Accounts",
        name: "get-accounts",
        display_name: "Get Accounts",
        method: "IMPORT",
        endgrate_type: "crm-company",
        supports_associations: false
      }
    ]
  },
  {
    provider: {
      name: "hubspot",
      display_name: "Hubspot",
      url: "https://www.hubspot.com/",
      image: "https://endgrate.nyc3.cdn.digitaloceanspaces.com/integration/hubspot.png",
      auth_type: "oauth",
      endgrate_provider_type: "CRM"
    },
    integrations: [
      {
        object_name: "companies",
        label: "Company",
        plural_label: "Companies",
        name: "get-companies",
        display_name: "Get Companies",
        method: "IMPORT",
        endgrate_type: "crm-company",
        supports_associations: true
      },
      {
        object_name: "contacts",
        label: "Contact",
        plural_label: "Contacts",
        name: "get-contacts",
        display_name: "Get Contacts",
        method: "IMPORT",
        endgrate_type: "crm-contact",
        supports_associations: true
      },
      {
        object_name: "deals",
        label: "Deal",
        plural_label: "Deals",
        name: "get-deals",
        display_name: "Get Deals",
        method: "IMPORT",
        endgrate_type: "crm-opportunity",
        supports_associations: true
      },
      {
        object_name: "products",
        label: "Product",
        plural_label: "Products",
        name: "get-products",
        display_name: "Get Products (Professional/Enterprise Only)",
        method: "IMPORT",
        endgrate_type: "crm-product",
        supports_associations: true
      },
      // {
      //     "object_name": "custom-objects",
      //     "label": "Custom-object",
      //     "plural_label": "Custom-objects",
      //     "name": "get-custom-objects",
      //     "display_name": "Get Custom Objects",
      //     "method": "IMPORT",
      //     "endgrate_type": "other",
      //     "supports_associations": false
      // },
      {
        object_name: "users",
        label: "User",
        plural_label: "Users",
        name: "get-users",
        display_name: "Get Users",
        method: "IMPORT",
        endgrate_type: "crm-user",
        supports_associations: false
      }
    ]
  },
  {
    provider: {
      name: "Insightly",
      display_name: "Insightly",
      url: "https://www.insightly.com/",
      image: "https://endgrate.nyc3.cdn.digitaloceanspaces.com/integration/insightly.png",
      auth_type: "api_key",
      endgrate_provider_type: "CRM"
    },
    integrations: [
      {
        object_name: "contacts",
        label: "Contact",
        plural_label: "Contacts",
        name: "get-contacts",
        display_name: "Get Contacts",
        method: "IMPORT",
        endgrate_type: "crm-contact",
        supports_associations: true
      },
      {
        object_name: "leads",
        label: "Lead",
        plural_label: "Leads",
        name: "get-leads",
        display_name: "Get Leads",
        method: "IMPORT",
        endgrate_type: "crm-lead",
        supports_associations: false
      },
      {
        object_name: "organizations",
        label: "Organization",
        plural_label: "Organizations",
        name: "get-organizations",
        display_name: "Get Organizations",
        method: "IMPORT",
        endgrate_type: "crm-company",
        supports_associations: false
      },
      {
        object_name: "users",
        label: "User",
        plural_label: "Users",
        name: "get-users",
        display_name: "Get Users",
        method: "IMPORT",
        endgrate_type: "crm-user",
        supports_associations: false
      }
    ]
  },
  {
    provider: {
      name: "keap",
      display_name: "Keap",
      url: "https://keap.com/",
      image: "https://endgrate.nyc3.cdn.digitaloceanspaces.com/integration/keap.png",
      auth_type: "oauth",
      endgrate_provider_type: "CRM"
    },
    integrations: [
      {
        object_name: "companies",
        label: "Company",
        plural_label: "Companies",
        name: "get-companies",
        display_name: "Get Companies",
        method: "IMPORT",
        endgrate_type: "crm-company",
        supports_associations: false
      },
      {
        object_name: "contacts",
        label: "Contact",
        plural_label: "Contacts",
        name: "get-contacts",
        display_name: "Get Contacts",
        method: "IMPORT",
        endgrate_type: "crm-contact",
        supports_associations: false
      },
      {
        object_name: "users",
        label: "User",
        plural_label: "Users",
        name: "get-users",
        display_name: "Get Users",
        method: "IMPORT",
        endgrate_type: "crm-user",
        supports_associations: false
      }
    ]
  },
  {
    provider: {
      name: "microsoftdynamics365",
      display_name: "Microsoft Dynamics 365",
      url: "https://dynamics.microsoft.com/en-us/",
      image: "https://endgrate.nyc3.cdn.digitaloceanspaces.com/integration/microsoftdynamics365.png",
      auth_type: "oauth",
      endgrate_provider_type: "CRM"
    },
    integrations: [
      {
        object_name: "contacts",
        label: "Contact",
        plural_label: "Contacts",
        name: "get-contacts",
        display_name: "Get Contacts",
        method: "IMPORT",
        endgrate_type: "crm-contact",
        supports_associations: false
      },
      {
        object_name: "custom-objects",
        label: "Custom-object",
        plural_label: "Custom-objects",
        name: "get-custom-objects",
        display_name: "Get Custom Objects",
        method: "IMPORT",
        endgrate_type: "other",
        supports_associations: false
      },
      {
        object_name: "accounts",
        label: "Account",
        plural_label: "Accounts",
        name: "get-accounts",
        display_name: "Get Accounts",
        method: "IMPORT",
        endgrate_type: "crm-company",
        supports_associations: false
      },
      {
        object_name: "users",
        label: "User",
        plural_label: "Users",
        name: "get-users",
        display_name: "Get Users",
        method: "IMPORT",
        endgrate_type: "crm-user",
        supports_associations: false
      }
    ]
  },
  {
    provider: {
      name: "nimble",
      display_name: "Nimble",
      url: "https://www.nimble.com",
      image: "https://endgrate.nyc3.cdn.digitaloceanspaces.com/integration/nimble.png",
      auth_type: "api_key",
      endgrate_provider_type: "CRM"
    },
    integrations: [
      {
        object_name: "contacts",
        label: "Contact",
        plural_label: "Contacts",
        name: "get-contacts",
        display_name: "Get Contacts",
        method: "IMPORT",
        endgrate_type: "crm-contact",
        supports_associations: false
      },
      {
        object_name: "companies",
        label: "Company",
        plural_label: "Companies",
        name: "get-companies",
        display_name: "Get Companies",
        method: "IMPORT",
        endgrate_type: "crm-company",
        supports_associations: false
      }
    ]
  },
  {
    provider: {
      name: "nutshell",
      display_name: "Nutshell",
      url: "https://www.nutshell.com/",
      image: "https://endgrate.nyc3.cdn.digitaloceanspaces.com/integration/nutshell.png",
      auth_type: "custom",
      endgrate_provider_type: "CRM"
    },
    integrations: [
      {
        object_name: "contacts",
        label: "Contact",
        plural_label: "Contacts",
        name: "get-contacts",
        display_name: "Get Contacts",
        method: "IMPORT",
        endgrate_type: "crm-contact",
        supports_associations: true
      },
      {
        object_name: "users",
        label: "User",
        plural_label: "Users",
        name: "get-users",
        display_name: "Get Users",
        method: "IMPORT",
        endgrate_type: "crm-user",
        supports_associations: false
      }
    ]
  },
  {
    provider: {
      name: "outreach",
      display_name: "Outreach",
      url: "https://www.outreach.io/",
      image: "https://endgrate.nyc3.cdn.digitaloceanspaces.com/integration/outreach.png",
      auth_type: "oauth",
      endgrate_provider_type: "CRM"
    },
    integrations: [
      {
        object_name: "accounts",
        label: "Account",
        plural_label: "Accounts",
        name: "get-accounts",
        display_name: "Get Accounts",
        method: "IMPORT",
        endgrate_type: "crm-company",
        supports_associations: false
      },
      {
        object_name: "prospects",
        label: "Prospect",
        plural_label: "Prospects",
        name: "get-prospects",
        display_name: "Get Prospects",
        method: "IMPORT",
        endgrate_type: "crm-lead",
        supports_associations: true
      },
      {
        object_name: "users",
        label: "User",
        plural_label: "Users",
        name: "get-users",
        display_name: "Get Users",
        method: "IMPORT",
        endgrate_type: "crm-user",
        supports_associations: false
      }
    ]
  },
  {
    provider: {
      name: "onepagecrm",
      display_name: "OnePageCRM",
      url: "https://www.onepagecrm.com/",
      image: "https://endgrate.nyc3.cdn.digitaloceanspaces.com/integration/onepagecrm.png",
      auth_type: "custom",
      endgrate_provider_type: "CRM"
    },
    integrations: [
      {
        object_name: "companies",
        label: "Company",
        plural_label: "Companies",
        name: "get_companies",
        display_name: "Get Companies",
        method: "IMPORT",
        endgrate_type: "crm-company",
        supports_associations: false
      },
      {
        object_name: "contacts",
        label: "Contact",
        plural_label: "Contacts",
        name: "get_contacts",
        display_name: "Get Contacts",
        method: "IMPORT",
        endgrate_type: "crm-contact",
        supports_associations: true
      },
      {
        object_name: "users",
        label: "User",
        plural_label: "Users",
        name: "get_users",
        display_name: "Get Users",
        method: "IMPORT",
        endgrate_type: "crm-user",
        supports_associations: false
      }
    ]
  },
  // https://endgrate.com/api/integrations?method=IMPORT
  // {
  //   "provider": {
  //     "name": "pipedrive",
  //     "display_name": "Pipedrive",
  //     "url": "https://www.pipedrive.com/",
  //     "image": "https://endgrate.nyc3.cdn.digitaloceanspaces.com/integration/pipedrive.png",
  //     "auth_type": "oauth",
  //     "specific": {

  //     },
  //     "endgrate_provider_type": "CRM",
  //     "private_integration_company_pk": null,
  //     "rating": null,
  //     "review": null,
  //     "api_documentation_urls": [
  //       "https://pipedrive.readme.io/docs/getting-started",
  //       "https://pipedrive.readme.io/docs/developer-sandbox-account",
  //       "https://pipedrive.readme.io/docs/marketplace-creating-a-proper-app",
  //       "https://pipedrive.readme.io/docs/core-api-concepts-rate-limiting",
  //       "https://pipedrive.readme.io/docs/core-api-concepts-pagination",
  //       "https://pipedrive.readme.io/docs/core-api-concepts-http-status-codes",
  //       "https://pipedrive.readme.io/docs/core-api-concepts-custom-fields"
  //     ],
  //     "api_blurb": null,
  //     "supports_field_selection": true
  //   },
  //   "integrations": [
  //     {
  //       "name": "get-organizations",
  //       "display_name": "Get Organization",
  //       "method": "IMPORT",
  //       "endgrate_type": "crm-company",
  //       "supports_associations": false,
  //       "private_integration_company_pk": null,
  //       "api_documentation_urls": [
  //         "https://developers.pipedrive.com/docs/api/v1/Organizations",
  //         "https://developers.pipedrive.com/docs/api/v1/OrganizationFields",
  //         "https://developers.pipedrive.com/docs/api/v1/OrganizationRelationships"
  //       ],
  //       "api_blurb": null
  //     },
  //     {
  //       "name": "get-people",
  //       "display_name": "Get People",
  //       "method": "IMPORT",
  //       "endgrate_type": "crm-contact",
  //       "supports_associations": true,
  //       "private_integration_company_pk": null,
  //       "api_documentation_urls": [
  //         "https://developers.pipedrive.com/docs/api/v1/Persons",
  //         "https://developers.pipedrive.com/docs/api/v1/PersonFields"
  //       ],
  //       "api_blurb": null
  //     },
  //     {
  //       "name": "get-deals",
  //       "display_name": "Get Deals",
  //       "method": "IMPORT",
  //       "endgrate_type": "crm-opportunity",
  //       "supports_associations": false,
  //       "private_integration_company_pk": null,
  //       "api_documentation_urls": [
  //         "https://developers.pipedrive.com/docs/api/v1/Deals",
  //         "https://developers.pipedrive.com/docs/api/v1/DealFields"
  //       ],
  //       "api_blurb": null
  //     },
  //     {
  //       "name": "get-users",
  //       "display_name": "Get Users",
  //       "method": "IMPORT",
  //       "endgrate_type": "crm-user",
  //       "supports_associations": false,
  //       "private_integration_company_pk": null,
  //       "api_documentation_urls": [
  //         "https://developers.pipedrive.com/docs/api/v1/Users"
  //       ],
  //       "api_blurb": null
  //     },
  //     {
  //       "name": "get-leads",
  //       "display_name": "Get Leads",
  //       "method": "IMPORT",
  //       "endgrate_type": "crm-lead",
  //       "supports_associations": false,
  //       "private_integration_company_pk": null,
  //       "api_documentation_urls": [
  //         "https://developers.pipedrive.com/docs/api/v1/Leads"
  //       ],
  //       "api_blurb": null
  //     }
  //   ]
  // },
  // {
  //   provider: {
  //     name: "pipedrive",
  //     display_name: "Pipedrive",
  //     url: "https://www.pipedrive.com/",
  //     image: "https://endgrate.nyc3.cdn.digitaloceanspaces.com/integration/pipedrive.png",
  //     auth_type: "oauth",
  //     endgrate_provider_type: "CRM"
  //   },
  //   integrations: [
  //     {
  //       object_name: "organizations",
  //       label: "Organization",
  //       plural_label: "Organizations",
  //       name: "get-organizations",
  //       display_name: "Get Organization",
  //       method: "IMPORT",
  //       endgrate_type: "crm-company",
  //       supports_associations: false
  //     },
  //     {
  //       object_name: "people",
  //       label: "Person",
  //       plural_label: "People",
  //       name: "get-people",
  //       display_name: "Get People",
  //       method: "IMPORT",
  //       endgrate_type: "crm-contact",
  //       supports_associations: false
  //     },
  //     {
  //       object_name: "deals",
  //       label: "Deal",
  //       plural_label: "Deals",
  //       name: "get-deals",
  //       display_name: "Get Deals",
  //       method: "IMPORT",
  //       endgrate_type: "crm-opportunity",
  //       supports_associations: false
  //     },
  //     {
  //       object_name: "users",
  //       label: "User",
  //       plural_label: "Users",
  //       name: "get-users",
  //       display_name: "Get Users",
  //       method: "IMPORT",
  //       endgrate_type: "crm-user",
  //       supports_associations: false
  //     },
  //     {
  //       object_name: "leads",
  //       label: "Lead",
  //       plural_label: "Leads",
  //       name: "get-leads",
  //       display_name: "Get Leads",
  //       method: "IMPORT",
  //       endgrate_type: "crm-lead",
  //       supports_associations: false
  //     }
  //   ]
  // },
  {
    provider: {
      name: "pipelinecrm",
      display_name: "PipelineCRM",
      url: "https://pipelinecrm.com/",
      image: "https://endgrate.nyc3.cdn.digitaloceanspaces.com/integration/pipelinecrm.png",
      auth_type: "api_key",
      endgrate_provider_type: "CRM"
    },
    integrations: [
      {
        object_name: "companies",
        label: "Company",
        plural_label: "Companies",
        name: "get-companies",
        display_name: "Get Companies",
        method: "IMPORT",
        endgrate_type: "crm-company",
        supports_associations: false
      },
      {
        object_name: "deals",
        label: "Deal",
        plural_label: "Deals",
        name: "get-deals",
        display_name: "Get Deals",
        method: "IMPORT",
        endgrate_type: "crm-opportunity",
        supports_associations: true
      },
      {
        object_name: "people",
        label: "Person",
        plural_label: "People",
        name: "get-people",
        display_name: "Get People",
        method: "IMPORT",
        endgrate_type: "crm-contact",
        supports_associations: true
      },
      {
        object_name: "users",
        label: "User",
        plural_label: "Users",
        name: "get-users",
        display_name: "Get Users",
        method: "IMPORT",
        endgrate_type: "crm-user",
        supports_associations: false
      }
    ]
  },
  {
    provider: {
      name: "pipelinercrm",
      display_name: "Pipeliner CRM",
      url: "www.pipelinersales.com",
      image: "https://endgrate.nyc3.cdn.digitaloceanspaces.com/integration/pipelinercrm.png",
      auth_type: "custom",
      endgrate_provider_type: "CRM"
    },
    integrations: [
      {
        object_name: "contacts",
        label: "Contact",
        plural_label: "Contacts",
        name: "get-contacts",
        display_name: "Get Contacts",
        method: "IMPORT",
        endgrate_type: "crm-contact",
        supports_associations: false
      },
      {
        object_name: "companies",
        label: "Company",
        plural_label: "Companies",
        name: "get-companies",
        display_name: "Get Companies",
        method: "IMPORT",
        endgrate_type: "crm-company",
        supports_associations: false
      }
    ]
  },
  {
    provider: {
      name: "salesflare",
      display_name: "Salesflare",
      url: "https://salesflare.com",
      image: "https://endgrate.nyc3.cdn.digitaloceanspaces.com/integration/salesflare.png",
      auth_type: "api_key",
      endgrate_provider_type: "CRM"
    },
    integrations: [
      {
        object_name: "contacts",
        label: "Contact",
        plural_label: "Contacts",
        name: "get-contacts",
        display_name: "Get Contacts",
        method: "IMPORT",
        endgrate_type: "crm-contact",
        supports_associations: true
      },
      {
        object_name: "accounts",
        label: "Account",
        plural_label: "Accounts",
        name: "get-accounts",
        display_name: "Get Accounts",
        method: "IMPORT",
        endgrate_type: "crm-company",
        supports_associations: false
      },
      {
        object_name: "users",
        label: "User",
        plural_label: "Users",
        name: "get-users",
        display_name: "Get Users",
        method: "IMPORT",
        endgrate_type: "crm-user",
        supports_associations: false
      }
    ]
  },
  {
    provider: {
      name: "salesloft",
      display_name: "Salesloft",
      url: "https://salesloft.com/",
      image: "https://endgrate.nyc3.cdn.digitaloceanspaces.com/integration/salesloft.png",
      auth_type: "oauth",
      endgrate_provider_type: "CRM"
    },
    integrations: [
      {
        object_name: "accounts",
        label: "Account",
        plural_label: "Accounts",
        name: "get-accounts",
        display_name: "Get Accounts",
        method: "IMPORT",
        endgrate_type: "crm-company",
        supports_associations: false
      },
      {
        object_name: "calls",
        label: "Call",
        plural_label: "Calls",
        name: "get-calls",
        display_name: "Get Calls",
        method: "IMPORT",
        endgrate_type: "other",
        supports_associations: true
      },
      {
        object_name: "people",
        label: "Person",
        plural_label: "People",
        name: "get-people",
        display_name: "Get People",
        method: "IMPORT",
        endgrate_type: "crm-contact",
        supports_associations: true
      },
      {
        object_name: "notes",
        label: "Note",
        plural_label: "Notes",
        name: "get-notes",
        display_name: "Get Notes",
        method: "IMPORT",
        endgrate_type: "crm-note",
        supports_associations: true
      },
      {
        object_name: "tasks",
        label: "Task",
        plural_label: "Tasks",
        name: "get-tasks",
        display_name: "Get Tasks",
        method: "IMPORT",
        endgrate_type: "crm-task",
        supports_associations: true
      },
      {
        object_name: "users",
        label: "User",
        plural_label: "Users",
        name: "get-users",
        display_name: "Get Users",
        method: "IMPORT",
        endgrate_type: "crm-user",
        supports_associations: false
      }
    ]
  },
  {
    provider: {
      name: "sugarmarket",
      display_name: "Sugar Market",
      url: "https://www.sugarcrm.com/solutions/sugar-market/",
      image: "https://endgrate.nyc3.cdn.digitaloceanspaces.com/integration/sugarcrm.png",
      auth_type: "custom",
      endgrate_provider_type: "CRM"
    },
    integrations: [
      {
        object_name: "accounts",
        label: "Account",
        plural_label: "Accounts",
        name: "get-accounts",
        display_name: "Get Accounts",
        method: "IMPORT",
        endgrate_type: "crm-company",
        supports_associations: false
      },
      {
        object_name: "contacts",
        label: "Contact",
        plural_label: "Contacts",
        name: "get-contacts",
        display_name: "Get Contacts",
        method: "IMPORT",
        endgrate_type: "crm-contact",
        supports_associations: false
      },
      {
        object_name: "opportunities",
        label: "Opportunity",
        plural_label: "Opportunities",
        name: "get-opportunities",
        display_name: "Get Opportunities",
        method: "IMPORT",
        endgrate_type: "crm-opportunity",
        supports_associations: false
      },
      {
        object_name: "tasks",
        label: "Task",
        plural_label: "Tasks",
        name: "get-tasks",
        display_name: "Get Tasks",
        method: "IMPORT",
        endgrate_type: "crm-task",
        supports_associations: false
      }
    ]
  },
  {
    provider: {
      name: "teamleader",
      display_name: "Teamleader",
      url: "teamleader.eu",
      image: "https://endgrate.nyc3.cdn.digitaloceanspaces.com/integration/teamleader.png",
      auth_type: "oauth",
      endgrate_provider_type: "CRM"
    },
    integrations: [
      {
        object_name: "contact",
        label: "Contact",
        plural_label: "Contacts",
        name: "get-contact",
        display_name: "Get Contacts",
        method: "IMPORT",
        endgrate_type: "crm-contact",
        supports_associations: false
      },
      {
        object_name: "companies",
        label: "Company",
        plural_label: "Companies",
        name: "get-companies",
        display_name: "Get Companies",
        method: "IMPORT",
        endgrate_type: "crm-company",
        supports_associations: false
      }
    ]
  },
  {
    provider: {
      name: "teamworkcrm",
      display_name: "Teamwork CRM",
      url: "https://www.teamwork.com/crm/",
      image: "https://endgrate.nyc3.cdn.digitaloceanspaces.com/integration/teamwork.png",
      auth_type: "custom",
      endgrate_provider_type: "CRM"
    },
    integrations: [
      {
        object_name: "contacts",
        label: "Contact",
        plural_label: "Contacts",
        name: "get-contacts",
        display_name: "Get Contacts",
        method: "IMPORT",
        endgrate_type: "crm-contact",
        supports_associations: true
      },
      {
        object_name: "companies",
        label: "Company",
        plural_label: "Companies",
        name: "get-companies",
        display_name: "Get Companies",
        method: "IMPORT",
        endgrate_type: "crm-company",
        supports_associations: false
      },
      {
        object_name: "users",
        label: "User",
        plural_label: "Users",
        name: "get-users",
        display_name: "Get Users",
        method: "IMPORT",
        endgrate_type: "crm-user",
        supports_associations: false
      }
    ]
  },
  {
    provider: {
      name: "woodpecker",
      display_name: "Woodpecker",
      url: "https://woodpecker.co/",
      image: "https://endgrate.nyc3.cdn.digitaloceanspaces.com/integration/woodpecker.png",
      auth_type: "api_key",
      endgrate_provider_type: "CRM"
    },
    integrations: [
      {
        object_name: "prospects",
        label: "Prospect",
        plural_label: "Prospects",
        name: "get-prospects",
        display_name: "Get Prospects",
        method: "IMPORT",
        endgrate_type: "crm-lead",
        supports_associations: false
      }
    ]
  },
  {
    provider: {
      name: "zohocrm",
      display_name: "Zoho CRM",
      url: "https://www.zoho.com/crm/",
      image: "https://endgrate.nyc3.cdn.digitaloceanspaces.com/integration/zohocrm.png",
      auth_type: "oauth",
      endgrate_provider_type: "CRM"
    },
    integrations: [
      {
        object_name: "accounts",
        label: "Account",
        plural_label: "Accounts",
        name: "get-accounts",
        display_name: "Get Accounts",
        method: "IMPORT",
        endgrate_type: "crm-company",
        supports_associations: true
      },
      {
        object_name: "contacts",
        label: "Contact",
        plural_label: "Contacts",
        name: "get-contacts",
        display_name: "Get Contacts",
        method: "IMPORT",
        endgrate_type: "crm-contact",
        supports_associations: true
      },
      {
        object_name: "deals",
        label: "Deal",
        plural_label: "Deals",
        name: "get-deals",
        display_name: "Get Deals",
        method: "IMPORT",
        endgrate_type: "crm-opportunity",
        supports_associations: true
      },
      {
        object_name: "leads",
        label: "Lead",
        plural_label: "Leads",
        name: "get-leads",
        display_name: "Get Leads",
        method: "IMPORT",
        endgrate_type: "crm-lead",
        supports_associations: true
      },
      {
        object_name: "notes",
        label: "Note",
        plural_label: "Notes",
        name: "get-notes",
        display_name: "Get Notes",
        method: "IMPORT",
        endgrate_type: "crm-note",
        supports_associations: false
      },
      {
        object_name: "tasks",
        label: "Task",
        plural_label: "Tasks",
        name: "get-tasks",
        display_name: "Get Tasks",
        method: "IMPORT",
        endgrate_type: "crm-task",
        supports_associations: false
      },
      {
        object_name: "users",
        label: "User",
        plural_label: "Users",
        name: "get-users",
        display_name: "Get Users",
        method: "IMPORT",
        endgrate_type: "crm-user",
        supports_associations: false
      }
      // {
      //     "object_name": "custom-objects",
      //     "label": "Custom-object",
      //     "plural_label": "Custom-objects",
      //     "name": "get-custom-objects",
      //     "display_name": "Get Custom Objects",
      //     "method": "IMPORT",
      //     "endgrate_type": "other",
      //     "supports_associations": false
      // }
    ]
  },
  {
    provider: {
      name: "zendesksell",
      display_name: "Zendesk Sell",
      url: "https://www.zendesk.com/sell/",
      image: "https://endgrate.nyc3.cdn.digitaloceanspaces.com/integration/zendesksell.png",
      auth_type: "oauth",
      endgrate_provider_type: "CRM"
    },
    integrations: [
      {
        object_name: "leads",
        label: "Lead",
        plural_label: "Leads",
        name: "get-leads",
        display_name: "Get Leads",
        method: "IMPORT",
        endgrate_type: "crm-lead",
        supports_associations: false
      },
      {
        object_name: "users",
        label: "User",
        plural_label: "Users",
        name: "get-users",
        display_name: "Get Users",
        method: "IMPORT",
        endgrate_type: "crm-user",
        supports_associations: false
      }
    ]
  },
  {
    provider: {
      name: "chargebee",
      display_name: "Chargebee",
      url: "https://www.chargebee.com/",
      image: "https://endgrate.nyc3.cdn.digitaloceanspaces.com/integration/chargebee.png",
      auth_type: "custom",
      endgrate_provider_type: "Accounting"
    },
    integrations: [
      //   {
      //       "object_name": "credit-notes",
      //       "label": "Credit-note",
      //       "plural_label": "Credit-notes",
      //       "name": "get-credit-notes",
      //       "display_name": "Get Credit Notes",
      //       "method": "IMPORT",
      //       "endgrate_type": "accounting-credit_note",
      //       "supports_associations": false
      //   },
      {
        object_name: "customers",
        label: "Customer",
        plural_label: "Customers",
        name: "get-customers",
        display_name: "Get Customers",
        method: "IMPORT",
        endgrate_type: "accounting-customer",
        supports_associations: false
      },
      // Removed for Reelo - 2024-06-13
      // {
      //     "object_name": "events",
      //     "label": "Event",
      //     "plural_label": "Events",
      //     "name": "get-events",
      //     "display_name": "Get Events",
      //     "method": "IMPORT",
      //     "endgrate_type": "other",
      //     "supports_associations": false
      // },
      {
        object_name: "invoices",
        label: "Invoice",
        plural_label: "Invoices",
        name: "get-invoices",
        display_name: "Get Invoices",
        method: "IMPORT",
        endgrate_type: "accounting-invoice",
        supports_associations: false
      },
      {
        object_name: "payments",
        label: "Payment",
        plural_label: "Payments",
        name: "get-payments",
        display_name: "Get Payments",
        method: "IMPORT",
        endgrate_type: "accounting-payment",
        supports_associations: false
      },
      {
        object_name: "product-catalog",
        label: "Product-catalog",
        plural_label: "Product-catalogs",
        name: "get-product-catalog",
        display_name: "Get Product Catalog",
        method: "IMPORT",
        endgrate_type: "accounting-item",
        supports_associations: false
      },
      {
        object_name: "subscriptions",
        label: "Subscription",
        plural_label: "Subscriptions",
        name: "get-subscriptions",
        display_name: "Get Subscriptions",
        method: "IMPORT",
        endgrate_type: "accounting-subscription",
        supports_associations: false
      }
    ]
  },
  {
    provider: {
      name: "freeagent",
      display_name: "FreeAgent",
      url: "https://www.freeagent.com/us/",
      image: "https://endgrate.nyc3.cdn.digitaloceanspaces.com/integration/freeagent.png",
      auth_type: "oauth",
      endgrate_provider_type: "Accounting"
    },
    integrations: [
      {
        object_name: "contacts",
        label: "Contact",
        plural_label: "Contacts",
        name: "get-contacts",
        display_name: "Get Contacts",
        method: "IMPORT",
        endgrate_type: "accounting-customer",
        supports_associations: false
      }
    ]
  },
  {
    provider: {
      name: "moneybird",
      display_name: "Moneybird",
      url: "https://moneybird.com/",
      image: "https://endgrate.nyc3.cdn.digitaloceanspaces.com/integration/moneybird.png",
      auth_type: "oauth",
      endgrate_provider_type: "Accounting"
    },
    integrations: [
      {
        object_name: "contacts",
        label: "Contact",
        plural_label: "Contacts",
        name: "get-contacts",
        display_name: "Get Contacts",
        method: "IMPORT",
        endgrate_type: "accounting-customer",
        supports_associations: false
      },
      {
        object_name: "external-invoices",
        label: "External-invoice",
        plural_label: "External-invoices",
        name: "get-external-invoices",
        display_name: "Get External Invoices",
        method: "IMPORT",
        endgrate_type: "other",
        supports_associations: false
      },
      {
        object_name: "recurring-invoices",
        label: "Recurring-invoice",
        plural_label: "Recurring-invoices",
        name: "get-recurring-invoices",
        display_name: "Get Recurring Invoices",
        method: "IMPORT",
        endgrate_type: "accounting-invoice",
        supports_associations: false
      }
    ]
  },
  {
    provider: {
      name: "quickbooks",
      display_name: "Quickbooks",
      url: "https://quickbooks.intuit.com/",
      image: "https://endgrate.nyc3.cdn.digitaloceanspaces.com/integration/quickbooks.png",
      auth_type: "oauth",
      endgrate_provider_type: "Accounting"
    },
    integrations: [
      {
        object_name: "customers",
        label: "Customer",
        plural_label: "Customers",
        name: "get-customers",
        display_name: "Get Customers",
        method: "IMPORT",
        endgrate_type: "accounting-customer",
        supports_associations: false
      },
      {
        object_name: "invoices",
        label: "Invoice",
        plural_label: "Invoices",
        name: "get-invoices",
        display_name: "Get Invoices",
        method: "IMPORT",
        endgrate_type: "accounting-invoice",
        supports_associations: false
      },
      {
        object_name: "products",
        label: "Product",
        plural_label: "Products",
        name: "get-products",
        display_name: "Get Products",
        method: "IMPORT",
        endgrate_type: "accounting-item",
        supports_associations: false
      },
      {
        object_name: "purchase-orders",
        label: "Purchase-order",
        plural_label: "Purchase-orders",
        name: "get-purchase-orders",
        display_name: "Get Purchase Orders",
        method: "IMPORT",
        endgrate_type: "accounting-purchase_order",
        supports_associations: false
      }
    ]
  },
  {
    provider: {
      name: "sage",
      display_name: "Sage Accounting",
      url: "https://www.sage.com/",
      image: "https://endgrate.nyc3.cdn.digitaloceanspaces.com/integration/sage.png",
      auth_type: "oauth",
      endgrate_provider_type: "Accounting"
    },
    integrations: [
      {
        object_name: "contacts",
        label: "Contact",
        plural_label: "Contacts",
        name: "get-contacts",
        display_name: "Get Contacts",
        method: "IMPORT",
        endgrate_type: "accounting-customer",
        supports_associations: false
      },
      {
        object_name: "sales-invoices",
        label: "Sales-invoice",
        plural_label: "Sales-invoices",
        name: "get-sales-invoices",
        display_name: "Get Sales Invoices",
        method: "IMPORT",
        endgrate_type: "accounting-invoice",
        supports_associations: false
      },
      {
        object_name: "addresses",
        label: "Address",
        plural_label: "Addresses",
        name: "get-addresses",
        display_name: "Get Addresses",
        method: "IMPORT",
        endgrate_type: "other",
        supports_associations: false
      },
      {
        object_name: "contact-payments",
        label: "Contact-payment",
        plural_label: "Contact-payments",
        name: "get-contact-payments",
        display_name: "Get Contact Payments",
        method: "IMPORT",
        endgrate_type: "other",
        supports_associations: false
      },
      {
        object_name: "contact-people",
        label: "Contact-person",
        plural_label: "Contact-people",
        name: "get-contact-people",
        display_name: "Get Contact People",
        method: "IMPORT",
        endgrate_type: "other",
        supports_associations: false
      },
      {
        object_name: "products",
        label: "Product",
        plural_label: "Products",
        name: "get-products",
        display_name: "Get Products",
        method: "IMPORT",
        endgrate_type: "accounting-item",
        supports_associations: false
      },
      {
        object_name: "purchase-invoices",
        label: "Purchase-invoice",
        plural_label: "Purchase-invoices",
        name: "get-purchase-invoices",
        display_name: "Get Purchase Invoices",
        method: "IMPORT",
        endgrate_type: "accounting-purchase_order",
        supports_associations: false
      },
      {
        object_name: "customers",
        label: "Customer",
        plural_label: "Customers",
        name: "get-customers",
        display_name: "Get Customers",
        method: "IMPORT",
        endgrate_type: "accounting-customer",
        supports_associations: false
      }
    ]
  },
  {
    provider: {
      name: "sapbusinessone",
      display_name: "Sap Business One",
      url: "https://www.sap.com/products/erp/business-one.html/",
      image: "https://endgrate.nyc3.cdn.digitaloceanspaces.com/integration/sap.png",
      auth_type: "custom",
      endgrate_provider_type: "Accounting"
    },
    integrations: [
      {
        object_name: "customers",
        label: "Customer",
        plural_label: "Customers",
        name: "get-customers",
        display_name: "Get Customers",
        method: "IMPORT",
        endgrate_type: "accounting-customer",
        supports_associations: false
      },
      {
        object_name: "invoices",
        label: "Invoice",
        plural_label: "Invoices",
        name: "get-invoices",
        display_name: "Get Invoices",
        method: "IMPORT",
        endgrate_type: "accounting-invoice",
        supports_associations: false
      },
      {
        object_name: "items",
        label: "Item",
        plural_label: "Items",
        name: "get-items",
        display_name: "Get Items",
        method: "IMPORT",
        endgrate_type: "accounting-item",
        supports_associations: false
      },
      {
        object_name: "orders",
        label: "Order",
        plural_label: "Orders",
        name: "get-orders",
        display_name: "Get Orders",
        method: "IMPORT",
        endgrate_type: "accounting-sales_order",
        supports_associations: false
      },
      {
        object_name: "purchase-orders",
        label: "Purchase-order",
        plural_label: "Purchase-orders",
        name: "get-purchase-orders",
        display_name: "Get Purchase Orders",
        method: "IMPORT",
        endgrate_type: "accounting-purchase_order",
        supports_associations: false
      },
      {
        object_name: "vendors",
        label: "Vendor",
        plural_label: "Vendors",
        name: "get-vendors",
        display_name: "Get Vendors",
        method: "IMPORT",
        endgrate_type: "accounting-vendor",
        supports_associations: false
      }
    ]
  },
  {
    provider: {
      name: "xero",
      display_name: "Xero",
      url: "https://www.xero.com/",
      image: "https://endgrate.nyc3.cdn.digitaloceanspaces.com/integration/xero.png",
      auth_type: "oauth",
      endgrate_provider_type: "Accounting"
    },
    integrations: [
      {
        object_name: "contacts",
        label: "Contact",
        plural_label: "Contacts",
        name: "get-contacts",
        display_name: "Get Contacts",
        method: "IMPORT",
        endgrate_type: "accounting-customer",
        supports_associations: false
      }
    ]
  },
  {
    provider: {
      name: "younium",
      display_name: "Younium",
      url: "https://www.younium.com/",
      image: "https://endgrate.nyc3.cdn.digitaloceanspaces.com/integration/younium.png",
      auth_type: "custom",
      endgrate_provider_type: "Accounting"
    },
    integrations: [
      {
        object_name: "accounts",
        label: "Account",
        plural_label: "Accounts",
        name: "get-accounts",
        display_name: "Get Accounts",
        method: "IMPORT",
        endgrate_type: "accounting-account",
        supports_associations: false
      },
      {
        object_name: "invoices",
        label: "Invoice",
        plural_label: "Invoices",
        name: "get-invoices",
        display_name: "Get Invoices",
        method: "IMPORT",
        endgrate_type: "accounting-invoice",
        supports_associations: false
      },
      {
        object_name: "payments",
        label: "Payment",
        plural_label: "Payments",
        name: "get-payments",
        display_name: "Get Payments",
        method: "IMPORT",
        endgrate_type: "other",
        supports_associations: false
      },
      {
        object_name: "products",
        label: "Product",
        plural_label: "Products",
        name: "get-products",
        display_name: "Get Products",
        method: "IMPORT",
        endgrate_type: "accounting-item",
        supports_associations: false
      },
      {
        object_name: "orders",
        label: "Order",
        plural_label: "Orders",
        name: "get-orders",
        display_name: "Get Orders",
        method: "IMPORT",
        endgrate_type: "accounting-sales_order",
        supports_associations: false
      }
    ]
  },
  {
    provider: {
      name: "zohobooks",
      display_name: "Zoho Books",
      url: "https://www.zoho.com/books",
      image: "https://endgrate.nyc3.cdn.digitaloceanspaces.com/integration/zohobooks.png",
      auth_type: "oauth",
      endgrate_provider_type: "Accounting"
    },
    integrations: [
      {
        object_name: "contacts",
        label: "Contact",
        plural_label: "Contacts",
        name: "get-contacts",
        display_name: "Get Contacts",
        method: "IMPORT",
        endgrate_type: "accounting-customer",
        supports_associations: false
      },
      {
        object_name: "invoices",
        label: "Invoice",
        plural_label: "Invoices",
        name: "get-invoices",
        display_name: "Get Invoices",
        method: "IMPORT",
        endgrate_type: "accounting-invoice",
        supports_associations: false
      }
    ]
  },
  {
    provider: {
      name: "avalara",
      display_name: "Avalara",
      url: "https://www.avalara.com/",
      image: "https://endgrate.nyc3.cdn.digitaloceanspaces.com/integration/avalara.png",
      auth_type: "custom",
      endgrate_provider_type: "Accounting"
    },
    integrations: [
      {
        object_name: "tax",
        label: "Tax",
        plural_label: "Taxes",
        name: "get-tax",
        display_name: "Get Tax",
        method: "IMPORT",
        endgrate_type: "other",
        supports_associations: false
      }
    ]
  },
  // {
  //   provider: {
  //     name: "snowflake",
  //     display_name: "Snowflake",
  //     url: "https://www.snowflake.com/en/",
  //     image: "https://endgrate.nyc3.cdn.digitaloceanspaces.com/integration/snowflake.png",
  //     auth_type: "oauth",
  //     endgrate_provider_type: "Database"
  //   },
  //   integrations: [
  //     {
  //       object_name: "records",
  //       label: "Record",
  //       plural_label: "Records",
  //       name: "get-records",
  //       display_name: "Get Records",
  //       method: "IMPORT",
  //       endgrate_type: "other",
  //       supports_associations: false
  //     }
  //   ]
  // },
  {
    provider: {
      name: "front",
      display_name: "Front",
      url: "https://front.com/",
      image: "https://endgrate.nyc3.cdn.digitaloceanspaces.com/integration/front.png",
      auth_type: "api_key",
      endgrate_provider_type: "Helpdesk"
    },
    integrations: [
      {
        object_name: "contacts",
        label: "Contact",
        plural_label: "Contacts",
        name: "get-contacts",
        display_name: "Get Contacts",
        method: "IMPORT",
        endgrate_type: "helpdesk-contact",
        supports_associations: false
      },
      {
        object_name: "accounts",
        label: "Account",
        plural_label: "Accounts",
        name: "get-accounts",
        display_name: "Get Accounts",
        method: "IMPORT",
        endgrate_type: "helpdesk-company",
        supports_associations: false
      },
      {
        object_name: "conversations",
        label: "Conversation",
        plural_label: "Conversations",
        name: "get-conversations",
        display_name: "Get Conversations",
        method: "IMPORT",
        endgrate_type: "helpdesk-ticket",
        supports_associations: false
      }
    ]
  },
  {
    provider: {
      name: "jira",
      display_name: "Jira",
      url: "https://www.atlassian.com/software/jira",
      image: "https://endgrate.nyc3.cdn.digitaloceanspaces.com/integration/jira.png",
      auth_type: "oauth",
      endgrate_provider_type: "Workspace"
    },
    integrations: [
      {
        object_name: "issues",
        label: "Issue",
        plural_label: "Issues",
        name: "get-issues",
        display_name: "Get Issues",
        method: "IMPORT",
        endgrate_type: "workspace-task",
        supports_associations: false
      },
      {
        object_name: "users",
        label: "User",
        plural_label: "Users",
        name: "get-users",
        display_name: "Get Users",
        method: "IMPORT",
        endgrate_type: "workspace-user",
        supports_associations: false
      }
    ]
  }
]

async function fetchAndTransformIntegrations() {
  try {
    const response = await fetch("https://endgrate.com/api/integrations?method=IMPORT")
    const {
      data: { categories }
    } = await response.json()

    // Get the CRM category providers
    const crmProviders = categories.CRM || []

    // Transform the CRM providers into the desired format
    const transformedData = crmProviders.map((item) => {
      const { provider, integrations } = item

      // Transform provider data
      const transformedProvider = {
        name: provider.name,
        display_name: provider.display_name,
        url: provider.url,
        image: provider.image,
        auth_type: provider.auth_type,
        endgrate_provider_type: provider.endgrate_provider_type
      }

      // Transform integrations data
      const transformedIntegrations = integrations.map((integration) => {
        // Extract object name from the integration name (remove 'get-' prefix)
        const object_name = integration.name.replace("get-", "")

        // Create singular label (capitalize first letter and remove 's' from end)
        const label = object_name.charAt(0).toUpperCase() + object_name.slice(1).replace(/s$/, "")

        // Create plural label (special case for 'people')
        const plural_label = object_name === "people" ? "People" : object_name.charAt(0).toUpperCase() + object_name.slice(1)

        return {
          object_name,
          label,
          plural_label,
          name: integration.name,
          display_name: integration.display_name,
          method: integration.method,
          endgrate_type: integration.endgrate_type,
          supports_associations: integration.supports_associations
        }
      })

      return {
        provider: transformedProvider,
        integrations: transformedIntegrations
      }
    })

    return transformedData
  } catch (error) {
    console.error("Error fetching and transforming integrations:", error)
    throw error
  }
}

const getSchema = (integration_name) => {
  return MERGELINK_INTEGRATIONS.find((i) => i.provider.name === integration_name).integrations.map((i) => {
    if (i.supports_associations) {
      return { title: i.name, properties: {}, associations: true }
    } else {
      return { title: i.name, properties: {} }
    }
  })
}
const getServiceTitle = (integration_name) => {
  let integrations_title = {
    hubspot: "HubSpot",
    salesforce: "Salesforce",
    postgres: "PostgresSQL",
    mysql: "MySQL",
    duckdb: "DuckDB",
    mongodb: "MongoDB"
  }
  if (integrations_title[integration_name]) {
    return integrations_title[integration_name]
  } else if (MERGELINK_INTEGRATIONS.find((i) => i.provider.name === integration_name)) {
    return MERGELINK_INTEGRATIONS.find((i) => i.provider.name === integration_name).provider.display_name
  } else {
    return integration_name.title()
  }
}

export { getSchema, getServiceTitle, MERGELINK_INTEGRATIONS, fetchAndTransformIntegrations }
